import { truktApi } from '@api';
import { v1 as uuid } from 'uuid';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getErrorMessage } from '@trukt/portal-utils/getErrorMessage';
import { useProgressNotifierContext } from '@trukt/ui/ProgressNotifierContext';
import { QUERY_CACHE_IDS_MAP } from '@types';

import { UseUpdateReportMutationResult } from './useUpdateReportMutation.types';

export const useUpdateReportMutation = () => {
  const progressNotifierContext = useProgressNotifierContext();

  const queryClient = useQueryClient();

  const mutation: UseUpdateReportMutationResult = useMutation({
    mutationFn: (request) => truktApi.report.update(request),

    onError: (error, _variables, _context) => {
      const progressNotifierId = uuid();
      progressNotifierContext.dispatchNotification({
        id: progressNotifierId,
        label: 'Unable to update report',
        errorMessage: getErrorMessage(error),
        isError: true,
      });
    },

    onSuccess: (_data, variables, _context) => {
      /**
       * invalidating the query for the reports list and the report the user is viewing. This will keep the user
       * in since with current server state
       */
      queryClient.invalidateQueries({
        queryKey: [QUERY_CACHE_IDS_MAP.REPORTS],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_CACHE_IDS_MAP.REPORT, variables.routeParams.id],
      });
    },
  });

  return mutation;
};
